export const WORKSPACE_LABELS = {
  WORKSPACES: 'Workspaces',
  NEW_WORKSPACES: 'New Workspaces',
};

export const WORKSPACE_ERRORS = {
  DUPLICATE_NAME: 'workspace_create_duplicateError',
  GENERIC: 'workspace_create_error',
  AVATAR_UPLOAD_FAILED: 'Avatar upload failed',
};

export const WORKSPACE_SUCCESS = {
  CREATED: 'Workspace Created.',
};

export const WORKSPACE_MODAL_CONFIG = {
  SIZE: 'lg',
  WINDOW_CLASS: 'upload-modal-window',
  PERMISSION_MODAL_CLASS: 'company-roles-and-permission-modal',
  BACKDROP: 'static',
  KEYBOARD: false,
  AVATAR_ASPECT_RATIO: 4.25,
  AVATAR_WIDTH: 850,
};

export const WORKSPACE_PATHS = {
  WORKSPACES: '/workspaces',
  WORKSPACE_EDIT: '/workspace/edit',
};

export const WORKSPACE_KEYS = {
  NAME: 'name',
  BRAND_ID: 'brandId',
  ADVERTISER: 'ADVERTISER',
  STRING: 'string',
  ACTIVE_COMPLETED: 'ACTIVE_COMPLETED',
  ACTIVE_COMPLETED_LABEL: 'Active Completed',
  PENDING_INPROGRESS: 'PENDING_INPROGRESS',
  PENDING_INPROGRESS_LABEL: 'Pending In Progress',
  REFRESH_TIMEOUT: 100,
  AUTOSAVE_DEBOUNCE: 1000,
  CACHE_BUSTER_PARAM: '?v=',
  NO_HTML_VALIDATOR: 'noHtmlValidator',
  HTML_NOT_ALLOWED: 'htmlNotAllowed',
  INVALID_CHARS_REGEX: /[^a-zA-Z0-9 ]/g,
  ERROR_FETCHING: 'Error fetching data',
  AVATAR: 'avatar',
  COVER: 'cover',
};

export const STATES = {
  FULL_NAME: 'fullName',
  DUPLICATE_NAME: 'DUPLICATE_NAME',
  BRAND_ID: 'brandId',
  PENDING_INPROGRESS: 'PENDING_INPROGRESS',

  USER: 'user',
  USERNAME: 'username',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ACTION: 'action',
};

export const ROUTES = {
  ENTRY: '/entry',
  ROOT: '/',
  WORKSPACES: '/workspaces',
  PROJECTS: '/projects',
  WORKSPACE_CAMPAIGN_ROUTE: '/workspaces',
};

export const STORAGE_KEYS = {
  BRAND: 'brand',
  BRAND_ID: 'brandId',
};

export const TRANSLATION_KEYS = {
  WORKSPACE_DELETE_TITLE: 'workspace_delete_title',
  WORKSPACE_DELETE_CONFIRM: 'workspace_delete_confirm',
  YES: 'yes',
  NO: 'no',
  WORKSPACE_DELETE_ERROR: 'workspace_delete_error',
  OVERLAY_CHANGE_SAVE: 'overlayChangeSave',
  WORKSPACE_EDIT_DUPLICATE_ERROR: 'workspace_edit_duplicateError',
  WORKSPACE_EDIT_ERROR: 'workspace_edit_error',
  WORKSPACE_PERMISSIONS_LABEL: 'workspace_edit_workspacesPermissions',
  PROJECTS_PERMISSIONS_LABEL: 'workspace_edit_projectsPermissions',
  REMOVE_WORKSPACE: 'removeWorkspace',
  SAVE_CHANGES: 'saveChanges',
  WORKSPACE_ADD_USER_FAILED: 'workspace_addUserFailed',
  WORKSPACE_REMOVE_USER_FAILED: 'workspace_removeUserFailed',
  VALIDATION_FAILED: 'validationFailed',
  MANDATORY_FIELD_REQUIRED: 'mandatoryFieldRequired',
};

export const BREADCRUMB = {
  WORKSPACES_LABEL: 'Workspaces',
  SETTINGS_LABEL: 'Settings',
  WORKSPACE_PERMISSIONS_LABEL: 'Workspace’s Permissions',
  PROJECT_PERMISSIONS_LABEL: 'Project’s Permissions',
};

export const ERROR_CODES = {
  DUPLICATE_NAME: 'DUPLICATE_NAME',
};

export const UI = {
  HEADER_SUCCESS_TITLE: 'Success',
  HEADER_ERROR_TITLE: 'Error',
};

export const WORKSPACE_ACTION_KEYS = {
  REMOVE_USER_TITLE: 'workspace_removeUser',
  REMOVE_USER_CONFIRM: 'workspace_removeUser_confirm',
  CONFIRM_BUTTON: 'yes',
  CANCEL_BUTTON: 'no',
};

export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: '',
};

export const CSS_CLASSES = {
  HEADER_DROPDOWN_OPEN: 'header-dropdown-open',
};
